/* Prom Dollz — booking: the Bridal Web Solutions scheduler is embedded on the page and takes the
   booking (the only booking record, so it syncs to the POS). This adds the "styles to try" note. */
(function () {
  'use strict';
  var root = document.querySelector('[data-booking]');
  if (!root) return;
  var $ = function (s) { return root.querySelector(s); };
  var frameBox = $('[data-bk-frame]');

  if (frameBox) {
    var f = document.createElement('iframe');
    f.src = frameBox.getAttribute('data-src');
    f.title = 'Live appointment calendar';
    f.className = 'bk-frame__iframe';
    f.setAttribute('allow', 'payment');
    f.addEventListener('load', function () { var l = $('[data-bk-loading]'); if (l) l.hidden = true; });
    frameBox.appendChild(f);
  }

  // Google Ads "Book appointment" conversion. The calendar lives on another site, so its confirmation
  // screen can't be seen from here: count the first time the shopper starts using the calendar (focus
  // moves into it) or opens it in a new tab. Once per page view.
  var started = false;
  function bookingStarted(how) {
    if (started) return; started = true;
    if (window.PD && window.PD.track) window.PD.track('appointment_request', { location: 'appointment_page', method: how });
  }
  window.addEventListener('blur', function () {
    setTimeout(function () {
      var a = document.activeElement;
      if (a && a.tagName === 'IFRAME' && a.classList.contains('bk-frame__iframe')) bookingStarted('calendar');
    }, 0);
  });
  root.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('[data-track-location="booking_newtab"]')) bookingStarted('new_tab');
  });

  // What to paste into BWS "Notes": the wishlist code (pd-wishlist.js) when there is one, so a stylist can
  // open the dresses at /pages/wishlist; otherwise the style names. Source: ?code= / ?style= or the saved wishlist.
  var params = new URLSearchParams(location.search);
  var raw = (params.get('style') || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
  if (!raw.length) { try { raw = (JSON.parse(localStorage.getItem('pd_wishlist')) || []).slice(0, 20); } catch (err) { raw = []; } }
  var isHandle = function (s) { return /^[a-z0-9]+(-[a-z0-9]+)+$/.test(s); };
  var givenCode = (params.get('code') || '').trim();
  if ((!raw.length && !givenCode) || !$('[data-bk-styles]')) return;
  var codeReady = givenCode ? Promise.resolve(givenCode)
    : (window.PDWishCode && raw.length && raw.every(isHandle) ? window.PDWishCode.build(raw).catch(function () { return ''; }) : Promise.resolve(''));
  codeReady.then(function (code) {
    if (code) return 'Wishlist code: ' + code;
    return Promise.all(raw.slice(0, 6).map(function (s) {
      if (!isHandle(s)) return Promise.resolve(s); // already a style number
      return fetch('/products/' + s + '.js').then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) { return p ? p.title : s; }).catch(function () { return s; });
    })).then(function (names) { return 'Styles to try: ' + names.join(', '); });
  }).then(function (text) {
    $('[data-bk-styles-text]').textContent = text;
    $('[data-bk-styles]').hidden = false;
    $('[data-bk-copy]').addEventListener('click', function () {
      var btn = this;
      (navigator.clipboard ? navigator.clipboard.writeText(text) : Promise.reject())
        .then(function () { btn.textContent = 'Copied'; setTimeout(function () { btn.textContent = 'Copy'; }, 2000); })
        .catch(function () { window.prompt('Copy this into Notes:', text); });
    });
  });
})();
